import { useEffect, useState } from 'react'

import { loadStored, storeValue } from '@/lib/storage'

/**
 * `useState` dont la valeur est conservée d'une session à l'autre.
 *
 * Même signature que `useState`, ce qui permet de rendre une préférence
 * persistante sans rien changer au code qui l'utilise.
 */
export function useLocalState<T>(key: string, initial: T) {
  const [value, setValue] = useState<T>(() => loadStored(key, initial))

  useEffect(() => {
    storeValue(key, value)
  }, [key, value])

  return [value, setValue] as const
}
